import type { CustomIconProps } from '../CustomIcon';

export const TrashCheckIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 40,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.178 14V12C18.178 11.4696 18.3888 10.9609 18.7638 10.5858C19.1389 10.2107 19.6476 10 20.178 10H24.178C24.7085 10 25.2172 10.2107 25.5923 10.5858C25.9673 10.9609 26.178 11.4696 26.178 12V14M29.178 14V28C29.178 28.5304 28.9673 29.0391 28.5923 29.4142C28.2172 29.7893 27.7085 30 27.178 30H17.178C16.6476 30 16.1389 29.7893 15.7638 29.4142C15.3888 29.0391 15.178 28.5304 15.178 28V14H29.178Z'
        stroke='#76706D'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.178 14H15.178H31.178'
        stroke='#76706D'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.178 19V25'
        stroke='#76706D'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.178 19V25'
        stroke='#76706D'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle cx='12' cy='23' r='6' fill='#0F9F37' stroke='white' strokeWidth='2' />
      <path d='M9 22.5L11.3077 25L15 21' stroke='white' strokeWidth='1.5' />
    </svg>
  );
};
